export const errorLogger = (store) => (next) => (action) => {
  // if (/\w+_ERROR$/.test(action.type)) console.error(action.payload);
  return next(action)
}
